import { render } from "./InvoiceDiv.vue?vue&type=template&id=271461f0&scoped=true"
import script from "./InvoiceDiv.vue?vue&type=script&lang=js"
export * from "./InvoiceDiv.vue?vue&type=script&lang=js"

import "./InvoiceDiv.vue?vue&type=style&index=0&id=271461f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271461f0"]])

export default __exports__